import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToSignup } from "../../lib/scroll";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            initial={{ y: -70, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 border-b ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-brand-tint2 shadow-[0_8px_30px_-18px_rgba(194,24,91,0.35)]"
                    : "bg-transparent border-transparent"
            }`}
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
                <a
                    href="#top"
                    data-testid="header-logo-link"
                    aria-label="edunation — wróć na górę strony"
                    onClick={(e) => {
                        e.preventDefault();
                        window.__lenis
                            ? window.__lenis.scrollTo(0, { duration: 1.2 })
                            : window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                >
                    <img
                        src="/assets/logo.png"
                        alt="edunation — logo"
                        className="h-8 sm:h-9 w-auto"
                        data-testid="header-logo-image"
                    />
                </a>
                <button
                    type="button"
                    onClick={scrollToSignup}
                    data-testid="header-cta-button"
                    className="group relative inline-flex items-center gap-2 rounded-full bg-brand-deep px-5 sm:px-7 py-2.5 sm:py-3 text-sm sm:text-base font-bold text-white shadow-[0_10px_25px_-10px_rgba(194,24,91,0.7)] transition-[transform,background-color] duration-200 hover:bg-brand hover:scale-[1.03] active:scale-[0.97]"
                >
                    Zapisuję się
                    <span className="inline-block transition-transform duration-200 group-hover:translate-y-0.5">↓</span>
                </button>
            </div>
        </motion.header>
    );
}
